import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "../components/ScrollToTop";
import { AuthProvider } from "../contexts/AuthContext";
import Dashboard from "./Dashboard";
import DashboardPrivate from "./DashboardPrivate";
import ForgotPassword from "./ForgotPassword";
import Hints from "./Hints";
import Login from "./Login";
import Privacy from "./Privacy";
import PrivateRoute from "./PrivateRoute";
import SignUp from "./SignUp";

function App() {
  return (
    <>
      <ToastContainer />
      <Router>
        <AuthProvider>
          <ScrollToTop>
            <Routes>
              <Route exact path="/" element={<Dashboard />} />
              <Route path="/sign-up" element={<SignUp />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/hints" element={<Hints />} />
              <Route exact element={<PrivateRoute />}>
                <Route exact path="/my-items" element={<DashboardPrivate />} />
              </Route>
            </Routes>
          </ScrollToTop>
        </AuthProvider>
      </Router>
    </>
  );
}

export default App;
